<template>
  <v-card min-height="550">
    <v-row width="100%">
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('animal.dateOfAnimalRemoval')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{$t('animal.dateAnimalRemoved')}}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  {{
                    (currentAnimal.animalRemovalDate && currentAnimal.animalRemovalDate != '0000-00-00')
                      ? currentAnimal.animalRemovalDate
                      : $t('notSpecified')
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('animal.destinationPlaceRemovedAnimal')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{$t('animal.destinationPlaceRemovedAnimal')}}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  {{
                    currentAnimal.removedAnimalDestination
                      ? currentAnimal.removedAnimalDestination
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('animal.nameOfOperator')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span
                      >{{$t('animal.namePersonFillAnimalInformation')}}</span
                    >
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  {{
                    currentAnimal.operator
                      ? currentAnimal.operator
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('animal.reasonOfAnimalRemoval')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{$t('animal.reasonWhyTheAnimalIsRemoved')}}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  {{
                    currentAnimal.animalRemovalReason
                      ? currentAnimal.animalRemovalReason
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{$t('animal.processingDate')}}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span
                      >{{$t('animal.DateInformationFilledChanged')}}</span
                    >
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  {{
                    (currentAnimal.animalRemovalDate && currentAnimal.animalRemovalDate != '0000-00-00')
                      ? currentAnimal.animalRemovalDate
                      : "Not Specified"
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  created() {
    console.log("removal");
  },
  computed: {
    ...mapGetters(["currentAnimal"]),
  },
  data() {
    return {
      animalRemovalReasons: [
        { text: this.$t('animal.sale'), value: "1" },
        { text: this.$t('animal.slaughter'), value: "2" },
        { text: this.$t('animal.death'), value: "3" },
        { text: this.$t('animal.theft'), value: "4" },
        { text: this.$t('animal.other'), value: "5" },
      ],
    };
  },
};
</script>